import { render, staticRenderFns } from "./NotBudget.vue?vue&type=template&id=3327b8ad"
import script from "./NotBudget.vue?vue&type=script&lang=js"
export * from "./NotBudget.vue?vue&type=script&lang=js"
import style0 from "./NotBudget.vue?vue&type=style&index=0&id=3327b8ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports